import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import toast from 'react-hot-toast';
import API from '../utils/api';

const V1 = '#7F00FF', V2 = '#B163FF', V3 = '#51158C', V4 = '#2B0057';

const ArrowLeftIcon = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="19" y1="12" x2="5" y2="12" /><polyline points="12 19 5 12 12 5" />
  </svg>
);
const UserIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" /><circle cx="12" cy="7" r="4" />
  </svg>
);
const BookIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z" /><path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z" />
  </svg>
);
const CreditCardIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <rect x="1" y="4" width="22" height="16" rx="2" ry="2" /><line x1="1" y1="10" x2="23" y2="10" />
  </svg>
);
const ZapIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2" />
  </svg>
);
const CheckIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="20 6 9 17 4 12" />
  </svg>
);
const XIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" />
  </svg>
);
const AwardIcon = () => (
  <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="8" r="6" /><path d="M15.477 12.89L17 22l-5-3-5 3 1.523-9.11" />
  </svg>
);
const CalendarIcon = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="4" width="18" height="18" rx="2" ry="2" /><line x1="16" y1="2" x2="16" y2="6" /><line x1="8" y1="2" x2="8" y2="6" /><line x1="3" y1="10" x2="21" y2="10" />
  </svg>
);
const VideoIcon = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polygon points="23 7 16 12 23 17 23 7" /><rect x="1" y="5" width="15" height="14" rx="2" ry="2" />
  </svg>
);
const UploadIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="16 16 12 12 8 16" /><line x1="12" y1="12" x2="12" y2="21" /><path d="M20.39 18.39A5 5 0 0 0 18 9h-1.26A8 8 0 1 0 3 16.3" />
  </svg>
);

const CircuitBg = () => (
  <div style={{ position: 'absolute', inset: 0, pointerEvents: 'none', overflow: 'hidden', zIndex: 0, opacity: 0.07 }}>
    <svg viewBox="0 0 1400 800" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid slice" style={{ width: '100%', height: '100%' }}>
      <g stroke={V2} strokeWidth="0.9" fill="none">
        <line x1="0" y1="160" x2="320" y2="160" /><line x1="380" y1="160" x2="680" y2="160" />
        <line x1="0" y1="420" x2="210" y2="420" /><line x1="570" y1="420" x2="880" y2="420" />
        <circle cx="320" cy="160" r="5" fill={V1} opacity="0.9" /><circle cx="680" cy="160" r="4" fill={V2} opacity="0.9" />
      </g>
    </svg>
  </div>
);

const statusConfig = {
  pending:          { label: 'Pending',          color: 'var(--warning)', bg: 'rgba(245,166,35,0.12)',  border: 'rgba(245,166,35,0.3)'  },
  payment_verified: { label: 'Payment Verified', color: '#3b82f6',        bg: 'rgba(59,130,246,0.12)',  border: 'rgba(59,130,246,0.3)'  },
  approved:         { label: 'Approved',         color: 'var(--success)', bg: 'rgba(13,186,121,0.12)', border: 'rgba(13,186,121,0.3)'  },
  rejected:         { label: 'Rejected',         color: 'var(--danger)',  bg: 'rgba(240,65,85,0.12)',  border: 'rgba(240,65,85,0.3)'   },
  completed:        { label: 'Completed',        color: V2,               bg: 'rgba(127,0,255,0.10)',  border: 'rgba(127,0,255,0.3)'   },
};

const inputStyle = {
  width: '100%', background: 'var(--bg2)',
  border: '1.5px solid var(--border)', borderRadius: 10,
  color: 'var(--text)', fontFamily: "'Satoshi','DM Sans',sans-serif",
  fontSize: 14, padding: '11px 14px', outline: 'none',
  transition: 'border-color 0.2s, box-shadow 0.2s',
};

const SectionCard = ({ icon, title, children }) => (
  <div style={{
    background: 'var(--card-solid)', border: '1px solid var(--border)',
    borderRadius: 20, overflow: 'hidden', boxShadow: 'var(--shadow-card)',
  }}>
    <div style={{
      display: 'flex', alignItems: 'center', gap: 10,
      padding: '18px 24px', borderBottom: '1px solid var(--border)',
      background: 'var(--bg3)',
    }}>
      <span style={{ color: V2 }}>{icon}</span>
      <h3 style={{ fontSize: 15, fontWeight: 800, color: 'var(--text)', fontFamily: "'Inter',sans-serif" }}>{title}</h3>
    </div>
    <div style={{ padding: '20px 24px' }}>{children}</div>
  </div>
);

const DetailRow = ({ label, value, mono }) => (
  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', padding: '11px 0', borderBottom: '1px solid var(--border)', gap: 16, flexWrap: 'wrap' }}>
    <span style={{ color: 'var(--muted)', fontSize: 13.5 }}>{label}</span>
    <span style={{ fontSize: 13.5, fontWeight: 700, color: 'var(--text)', textAlign: 'right', fontFamily: mono ? "'Space Mono',monospace" : 'inherit' }}>{value}</span>
  </div>
);

const AdminApplicationDetail = () => {
  const { id } = useParams();
  const [app, setApp] = useState(null);
  const [loading, setLoading] = useState(true);
  const [actionLoading, setActionLoading] = useState(false);
  const [batchDate, setBatchDate] = useState('');
  const [batchLink, setBatchLink] = useState('');
  const [rejectionReason, setRejectionReason] = useState('');
  const [adminNotes, setAdminNotes] = useState('');
  const [certFile, setCertFile] = useState(null);
  const [genIdLoading, setGenIdLoading] = useState(false);

  const fetchApp = () => {
    API.get(`/admin/applications/${id}`)
      .then(r => { setApp(r.data); setAdminNotes(r.data.adminNotes || ''); })
      .finally(() => setLoading(false));
  };
  useEffect(() => { fetchApp(); }, [id]);

  const action = async (endpoint, data = {}) => {
    setActionLoading(true);
    try {
      await API.put(`/admin/applications/${id}/${endpoint}`, data);
      toast.success('Action completed!');
      fetchApp();
    } catch (err) {
      toast.error(err.response?.data?.message || 'Action failed');
    } finally { setActionLoading(false); }
  };

  const handleComplete = async () => {
    if (!certFile) { toast.error('Please upload a certificate PDF'); return; }
    if (!app.certificateId) { toast.error('Please generate a Certificate ID first'); return; }
    setActionLoading(true);
    try {
      const fd = new FormData(); fd.append('certificate', certFile);
      await API.put(`/admin/applications/${id}/complete`, fd, { headers: { 'Content-Type': 'multipart/form-data' } });
      toast.success('Certificate uploaded and issued!');
      fetchApp();
    } catch (err) { toast.error(err.response?.data?.message || 'Failed to upload certificate'); }
    finally { setActionLoading(false); }
  };

  const handleGenerateCertId = async () => {
    setGenIdLoading(true);
    try {
      await API.put(`/admin/applications/${id}/generate-cert-id`);
      toast.success('Certificate ID generated!');
      fetchApp();
    } catch (err) {
      toast.error(err.response?.data?.message || 'Failed to generate Certificate ID');
    } finally {
      setGenIdLoading(false);
    }
  };

  if (loading) return (
    <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: '100vh', gap: 16, background: 'var(--bg)', color: 'var(--muted)' }}>
      <div style={{ width: 36, height: 36, borderRadius: '50%', border: `3px solid ${V1}33`, borderTopColor: V1, animation: 'spin 0.8s linear infinite' }} />
      Loading application...
    </div>
  );
  if (!app) return <div style={{ textAlign: 'center', padding: '160px 0', background: 'var(--bg)', color: 'var(--muted)' }}>Application not found.</div>;

  const st = statusConfig[app.status] || statusConfig.pending;

  return (
    <div style={{ background: 'var(--bg)', color: 'var(--text)', minHeight: '100vh' }}>

      {/* HEADER */}
      <section style={{ padding: '120px 0 60px', position: 'relative', overflow: 'hidden', background: 'var(--bg)' }}>
        <CircuitBg />
        <div style={{ position: 'absolute', bottom: 0, right: 0, width: 300, height: 300, borderRadius: '50%', background: `radial-gradient(circle, var(--hero-orb) 0%, transparent 70%)`, pointerEvents: 'none' }} />
        <div className="container" style={{ position: 'relative', zIndex: 2 }}>
          <Link to="/admin/applications" style={{
            display: 'inline-flex', alignItems: 'center', gap: 6,
            color: 'var(--muted)', fontSize: 13.5, fontWeight: 600, marginBottom: 24, transition: 'color 0.2s',
          }}
            onMouseEnter={e => e.currentTarget.style.color = V2}
            onMouseLeave={e => e.currentTarget.style.color = 'var(--muted)'}
          >
            <ArrowLeftIcon /> Back to Applications
          </Link>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 16 }}>
            <div>
              <div className="section-label">APPLICATION DETAIL</div>
              <h1 style={{ fontSize: 'clamp(24px,3.5vw,40px)', fontWeight: 800, letterSpacing: '-0.025em', fontFamily: "'Inter',sans-serif" }}>
                {app.studentName}
              </h1>
              <p style={{ color: 'var(--muted)', fontSize: 14, marginTop: 4 }}>{app.studentEmail}</p>
            </div>
            <span style={{
              display: 'inline-flex', padding: '8px 20px', borderRadius: 999,
              fontSize: 13, fontWeight: 700,
              color: st.color, background: st.bg, border: `1.5px solid ${st.border}`,
            }}>{st.label}</span>
          </div>
        </div>
      </section>

      {/* MAIN CONTENT */}
      <section style={{ padding: '0 0 100px', background: 'var(--bg2)', borderTop: '1px solid var(--border)' }}>
        <div className="container" style={{ paddingTop: 40 }}>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 20 }} className="detail-grid">

            {/* Student Info */}
            <SectionCard icon={<UserIcon />} title="Student Details">
              <DetailRow label="Name"          value={app.studentName} />
              <DetailRow label="Email"         value={app.studentEmail} />
              <DetailRow label="Phone"         value={app.studentPhone} />
              <DetailRow label="Degree"        value={app.degree || app.qualification || 'N/A'} />
              <DetailRow label="College / School" value={app.collegeName || 'N/A'} />
              {app.message && (
                <div style={{ paddingTop: 14 }}>
                  <div style={{ color: 'var(--muted)', fontSize: 12, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.07em', marginBottom: 8 }}>Message</div>
                  <p style={{ fontSize: 14, lineHeight: 1.65, color: 'var(--text-2)' }}>{app.message}</p>
                </div>
              )}
            </SectionCard>

            {/* Course Info */}
            <SectionCard icon={<BookIcon />} title="Course Details">
              <DetailRow label="Course"   value={app.course?.title} />
              <DetailRow label="Duration" value={app.course?.duration} />
              <DetailRow label="Level"    value={app.course?.level} />
              <DetailRow label="Fee"      value={`₹${app.course?.fee?.toLocaleString()}`} />
            </SectionCard>

            {/* Payment Info */}
            <SectionCard icon={<CreditCardIcon />} title="Payment Details">
              <DetailRow label="Transaction ID" value={app.gpayTransactionId} mono />
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '11px 0', borderBottom: '1px solid var(--border)' }}>
                <span style={{ color: 'var(--muted)', fontSize: 13.5 }}>Amount Paid</span>
                <span style={{ fontSize: 20, fontWeight: 900, color: 'var(--success)', fontFamily: "'Inter',sans-serif" }}>₹{app.amountPaid?.toLocaleString()}</span>
              </div>
              <div style={{ marginTop: 16 }}>
                <div style={{ color: 'var(--muted)', fontSize: 12, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.07em', marginBottom: 10 }}>Payment Screenshot</div>
                <div style={{
                  borderRadius: 12, border: '1px solid var(--border)', overflow: 'hidden',
                  background: 'var(--bg3)',
                }}>
                  <img
                    src={app.paymentScreenshot}
                    alt="Payment Screenshot"
                    style={{ width: '100%', maxHeight: 320, objectFit: 'contain', display: 'block', background: 'var(--bg)' }}
                    onError={e => { e.target.style.display = 'none'; e.target.nextSibling.style.display = 'flex'; }}
                  />
                  <div style={{ display: 'none', alignItems: 'center', justifyContent: 'center', padding: '24px', color: 'var(--muted)', fontSize: 13 }}>
                    Image failed to load
                  </div>
                </div>
                <a
                  href={app.paymentScreenshot}
                  target="_blank"
                  rel="noreferrer"
                  style={{
                    display: 'inline-flex', alignItems: 'center', gap: 6, marginTop: 10,
                    color: '#3b82f6', fontSize: 13, fontWeight: 600, textDecoration: 'none',
                  }}
                >
                  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" /><polyline points="15 3 21 3 21 9" /><line x1="10" y1="14" x2="21" y2="3" />
                  </svg>
                  Open screenshot in new tab
                </a>
              </div>
            </SectionCard>

            {/* Actions */}
            <SectionCard icon={<ZapIcon />} title="Actions">

              {/* Pending → Verify Payment */}
              {app.status === 'pending' && (
                <div style={{ marginBottom: 20 }}>
                  <p style={{ color: 'var(--muted)', fontSize: 13.5, marginBottom: 14, lineHeight: 1.6 }}>
                    Verify the payment screenshot is authentic before proceeding.
                  </p>
                  <button disabled={actionLoading} onClick={() => action('verify-payment')} style={{
                    width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8,
                    padding: '13px', borderRadius: 10, border: 'none', cursor: actionLoading ? 'wait' : 'pointer',
                    background: 'var(--success)', color: '#fff', fontWeight: 800, fontSize: 14,
                    fontFamily: "'Satoshi','DM Sans',sans-serif",
                    opacity: actionLoading ? 0.7 : 1, transition: 'opacity 0.2s',
                  }}>
                    <CheckIcon /> Verify Payment
                  </button>
                </div>
              )}

              {/* Payment Verified → Approve */}
              {app.status === 'payment_verified' && (
                <div style={{ marginBottom: 16 }}>
                  {[
                    { label: 'Batch Start Date *', input: <input type="date" value={batchDate} min={new Date().toISOString().split('T')[0]} onChange={e => setBatchDate(e.target.value)} style={inputStyle} onFocus={e => { e.target.style.borderColor = `${V1}88`; e.target.style.boxShadow = `0 0 0 3px ${V1}22`; }} onBlur={e => { e.target.style.borderColor = 'var(--border)'; e.target.style.boxShadow = 'none'; }} /> },
                    { label: 'Online Class Link (Zoom/Meet)', input: <input value={batchLink} onChange={e => setBatchLink(e.target.value)} placeholder="https://meet.google.com/..." style={inputStyle} onFocus={e => { e.target.style.borderColor = `${V1}88`; e.target.style.boxShadow = `0 0 0 3px ${V1}22`; }} onBlur={e => { e.target.style.borderColor = 'var(--border)'; e.target.style.boxShadow = 'none'; }} /> },
                    { label: 'Admin Notes', input: <textarea value={adminNotes} onChange={e => setAdminNotes(e.target.value)} placeholder="Internal notes..." style={{ ...inputStyle, resize: 'vertical', minHeight: 80 }} onFocus={e => { e.target.style.borderColor = `${V1}88`; e.target.style.boxShadow = `0 0 0 3px ${V1}22`; }} onBlur={e => { e.target.style.borderColor = 'var(--border)'; e.target.style.boxShadow = 'none'; }} /> },
                  ].map(({ label, input }) => (
                    <div key={label} style={{ marginBottom: 14 }}>
                      <label style={{ display: 'block', fontSize: 11.5, color: 'var(--muted)', fontWeight: 800, letterSpacing: '0.08em', textTransform: 'uppercase', marginBottom: 7 }}>{label}</label>
                      {input}
                    </div>
                  ))}
                  <button disabled={actionLoading || !batchDate} onClick={() => action('approve', { batchDate, batchLink, adminNotes })} style={{
                    width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8,
                    padding: '13px', borderRadius: 10, border: 'none',
                    cursor: actionLoading || !batchDate ? 'not-allowed' : 'pointer',
                    background: `linear-gradient(135deg,${V1},${V3})`, color: '#fff', fontWeight: 800, fontSize: 14,
                    fontFamily: "'Satoshi','DM Sans',sans-serif",
                    opacity: actionLoading || !batchDate ? 0.6 : 1,
                    boxShadow: `0 4px 20px ${V1}44`, transition: 'opacity 0.2s',
                  }}>
                    <CheckIcon /> Approve &amp; Notify Student
                  </button>
                </div>
              )}

              {/* Approved → Generate Cert ID + Upload Certificate */}
              {app.status === 'approved' && (
                <div style={{ marginBottom: 16 }}>
                  {app.batchDate && (
                    <div style={{ background: 'rgba(13,186,121,0.08)', border: '1px solid rgba(13,186,121,0.2)', borderRadius: 10, padding: '12px 16px', marginBottom: 16 }}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: 8, color: 'var(--success)', fontSize: 13.5, fontWeight: 700, marginBottom: app.batchLink ? 8 : 0 }}>
                        <CalendarIcon /> Batch: {new Date(app.batchDate).toLocaleDateString('en-IN', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })}
                      </div>
                      {app.batchLink && (
                        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                          <VideoIcon />
                          <a href={app.batchLink} target="_blank" rel="noreferrer" style={{ color: '#3b82f6', fontSize: 13 }}>{app.batchLink}</a>
                        </div>
                      )}
                    </div>
                  )}

                  {/* STEP 1: Generate Certificate ID */}
                  <div style={{
                    background: app.certificateId ? `${V4}22` : 'var(--bg3)',
                    border: `1.5px solid ${app.certificateId ? V1 + '66' : 'var(--border)'}`,
                    borderRadius: 14, padding: '18px 20px', marginBottom: 16,
                  }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 10 }}>
                      <span style={{
                        width: 22, height: 22, borderRadius: '50%',
                        background: app.certificateId ? `linear-gradient(135deg,${V1},${V2})` : 'var(--border)',
                        color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center',
                        fontSize: 12, fontWeight: 900, flexShrink: 0,
                      }}>1</span>
                      <span style={{ fontSize: 13, fontWeight: 800, color: 'var(--text)', textTransform: 'uppercase', letterSpacing: '0.06em' }}>
                        Generate Certificate ID
                      </span>
                    </div>

                    {app.certificateId ? (
                      <>
                        <p style={{ color: 'var(--muted)', fontSize: 12.5, marginBottom: 10, lineHeight: 1.6 }}>
                          Certificate ID is ready. Embed it in your certificate design before uploading.
                        </p>
                        <div style={{
                          display: 'flex', alignItems: 'center', gap: 10,
                          background: 'var(--bg)', border: `1px solid ${V1}44`,
                          borderRadius: 10, padding: '10px 14px',
                        }}>
                          <span style={{
                            fontFamily: "'Space Mono',monospace", fontSize: 13.5, fontWeight: 700,
                            color: V2, flex: 1, wordBreak: 'break-all',
                          }}>{app.certificateId}</span>
                          <button
                            onClick={() => { navigator.clipboard.writeText(app.certificateId); toast.success('Copied to clipboard!'); }}
                            title="Copy ID"
                            style={{
                              background: `${V1}22`, border: `1px solid ${V1}44`,
                              borderRadius: 8, padding: '6px 10px', cursor: 'pointer',
                              color: V2, fontSize: 12, fontWeight: 700, flexShrink: 0,
                              transition: 'all 0.2s',
                            }}
                            onMouseEnter={e => { e.currentTarget.style.background = `${V1}44`; }}
                            onMouseLeave={e => { e.currentTarget.style.background = `${V1}22`; }}
                          >
                            Copy
                          </button>
                        </div>
                      </>
                    ) : (
                      <>
                        <p style={{ color: 'var(--muted)', fontSize: 12.5, marginBottom: 12, lineHeight: 1.6 }}>
                          Generate a unique Certificate ID first. Use this ID in your certificate design (PDF), then upload it below.
                        </p>
                        <button
                          disabled={genIdLoading}
                          onClick={handleGenerateCertId}
                          style={{
                            width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8,
                            padding: '12px', borderRadius: 10, border: 'none',
                            cursor: genIdLoading ? 'wait' : 'pointer',
                            background: `linear-gradient(135deg,${V1},${V3})`,
                            color: '#fff', fontWeight: 800, fontSize: 14,
                            fontFamily: "'Satoshi','DM Sans',sans-serif",
                            opacity: genIdLoading ? 0.7 : 1,
                            boxShadow: `0 4px 20px ${V1}44`,
                            transition: 'opacity 0.2s',
                          }}
                        >
                          {genIdLoading ? (
                            <>
                              <div style={{ width: 16, height: 16, borderRadius: '50%', border: '2px solid rgba(255,255,255,0.3)', borderTopColor: '#fff', animation: 'spin 0.7s linear infinite' }} />
                              Generating...
                            </>
                          ) : (
                            <>
                              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                                <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
                              </svg>
                              Generate Certificate ID
                            </>
                          )}
                        </button>
                      </>
                    )}
                  </div>

                  {/* STEP 2: Upload Certificate (only enabled after ID generated) */}
                  <div style={{
                    background: 'var(--bg3)',
                    border: `1.5px solid ${app.certificateId ? 'var(--border)' : 'var(--border)'}`,
                    borderRadius: 14, padding: '18px 20px',
                    opacity: app.certificateId ? 1 : 0.45,
                    pointerEvents: app.certificateId ? 'auto' : 'none',
                    transition: 'opacity 0.3s',
                  }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 10 }}>
                      <span style={{
                        width: 22, height: 22, borderRadius: '50%',
                        background: app.certificateId ? 'var(--success)' : 'var(--border)',
                        color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center',
                        fontSize: 12, fontWeight: 900, flexShrink: 0,
                      }}>2</span>
                      <span style={{ fontSize: 13, fontWeight: 800, color: 'var(--text)', textTransform: 'uppercase', letterSpacing: '0.06em' }}>
                        Upload Certificate PDF
                      </span>
                    </div>
                    <p style={{ color: 'var(--muted)', fontSize: 12.5, marginBottom: 12, lineHeight: 1.6 }}>
                      Upload the certificate PDF (with the ID embedded) and mark the course as complete.
                    </p>
                    <div style={{ marginBottom: 12 }}>
                      <label style={{ display: 'block', fontSize: 11.5, color: 'var(--muted)', fontWeight: 800, textTransform: 'uppercase', letterSpacing: '0.08em', marginBottom: 7 }}>
                        Upload Certificate (PDF) *
                      </label>
                      <input type="file" accept=".pdf" onChange={e => setCertFile(e.target.files[0])} style={{ ...inputStyle, cursor: 'pointer' }} />
                      {certFile && <p style={{ color: 'var(--success)', fontSize: 13, marginTop: 6, fontWeight: 600 }}>✓ {certFile.name}</p>}
                    </div>
                    <button disabled={actionLoading || !certFile} onClick={handleComplete} style={{
                      width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8,
                      padding: '13px', borderRadius: 10, border: 'none',
                      cursor: actionLoading || !certFile ? 'not-allowed' : 'pointer',
                      background: 'var(--success)', color: '#fff', fontWeight: 800, fontSize: 14,
                      fontFamily: "'Satoshi','DM Sans',sans-serif",
                      opacity: actionLoading || !certFile ? 0.6 : 1, transition: 'opacity 0.2s',
                    }}>
                      <UploadIcon /> Upload Certificate &amp; Mark Complete
                    </button>
                  </div>
                </div>
              )}

              {/* Completed */}
              {app.status === 'completed' && (
                <div style={{ textAlign: 'center', padding: '24px 16px' }}>
                  <div style={{ color: V2, display: 'flex', justifyContent: 'center', marginBottom: 12 }}><AwardIcon /></div>
                  <p style={{ color: V2, fontWeight: 800, fontSize: 16, marginBottom: 6, fontFamily: "'Inter',sans-serif" }}>Course Completed!</p>
                  <p style={{ color: 'var(--muted)', fontSize: 13 }}>Certificate issued.</p>
                  {app.certificateId && <p style={{ color: 'var(--muted)', fontSize: 12, marginTop: 6, fontFamily: "'Space Mono',monospace" }}>ID: {app.certificateId}</p>}
                </div>
              )}

              {/* Reject (for pending or payment_verified) */}
              {(app.status === 'pending' || app.status === 'payment_verified') && (
                <div style={{ marginTop: 16, paddingTop: 16, borderTop: '1px solid var(--border)' }}>
                  <div style={{ marginBottom: 12 }}>
                    <label style={{ display: 'block', fontSize: 11.5, color: 'var(--muted)', fontWeight: 800, textTransform: 'uppercase', letterSpacing: '0.08em', marginBottom: 7 }}>
                      Rejection Reason
                    </label>
                    <input value={rejectionReason} onChange={e => setRejectionReason(e.target.value)} placeholder="e.g. Payment not verified..." style={inputStyle}
                      onFocus={e => { e.target.style.borderColor = `var(--danger)`; e.target.style.boxShadow = `0 0 0 3px rgba(240,65,85,0.15)`; }}
                      onBlur={e => { e.target.style.borderColor = 'var(--border)'; e.target.style.boxShadow = 'none'; }}
                    />
                  </div>
                  <button disabled={actionLoading} onClick={() => action('reject', { rejectionReason })} style={{
                    width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8,
                    padding: '13px', borderRadius: 10, border: 'none', cursor: actionLoading ? 'wait' : 'pointer',
                    background: 'var(--danger)', color: '#fff', fontWeight: 800, fontSize: 14,
                    fontFamily: "'Satoshi','DM Sans',sans-serif",
                    opacity: actionLoading ? 0.7 : 1, transition: 'opacity 0.2s',
                  }}>
                    <XIcon /> Reject Application
                  </button>
                </div>
              )}
            </SectionCard>
          </div>
        </div>
      </section>

      <style>{`
        @keyframes spin { to { transform: rotate(360deg); } }
        @media (max-width: 860px) { .detail-grid { grid-template-columns: 1fr !important; } }
      `}</style>
    </div>
  );
};

export default AdminApplicationDetail;